
import * as React from 'react';
import AppComponentBase from '../../components/AppComponentBase';
import '../../fonts/Creativity-qZyx6.ttf';
import { L } from '../../lib/abpUtility';
import InfoHubStore from '../../stores/infohubStore';

import { inject, observer } from 'mobx-react';
import Stores from '../../stores/storeIdentifier';

import CategoryTitle from '../../components/Controls/Widgets/categoryTitle';

import IntegrationStore from '../../stores/integrationStore';
import InventoryStore from '../../stores/inventoryStore';
import MenuStore from '../../stores/menuStore';
import PaymentsStore from '../../stores/paymentStore';
import PeopleStore from '../../stores/peopleStore';
import ReportStore from '../../stores/reportStore';
import RoleStore from '../../stores/roleStore';
import SchedulingStore from '../../stores/schedulingStore';
import SessionStore from '../../stores/sessionStore';
import TeamStore from '../../stores/teamStore';
import WorkOrderStore from '../../stores/workOrderStore';
import { Card, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import CommunicationStore from '../../stores/communicationStore';
import UserStore from '../../stores/userStore';

export interface IModelsBaseProps {
    userStore: UserStore;
    sessionStore: SessionStore;
    communicationStore: CommunicationStore;
    infoHubStore: InfoHubStore;
    inventoryStore: InventoryStore;
    menuStore: MenuStore;
    paymentStore: PaymentsStore;
    peopleStore: PeopleStore;
    reportStore: ReportStore;
    roleStore: RoleStore;
    schedulingStore: SchedulingStore;
    teamStore: TeamStore;
    workOrderStore: WorkOrderStore;
    integrationStore: IntegrationStore;

}

export interface IModelsBaseState {
    currentTab: string;
    loading: boolean;
    deleteDrawerVisible: boolean;
    createModalVisible: boolean;
    editModalVisible: boolean;
    maxResultCount: number;
    skipCount: number;
    tenantId: number;
    filter: string;
    cardHeight: string;
    formSize: string;
    cardSize: string;
    searchSize: string;
    tableSize: string;
    isMobile: boolean;
    collapseTitle: boolean;

    currentUserID: number;
    currentLoginName: string;
    currentLoginLastName: string;
    profileImageID: number;
    profileImageURL: string;
    currentUsername: string;
    currentEmailAddres: string;

    currentTenantName: string;
    primaryTenantColor: string;
    secondaryTenantColor: string;

    tenantImageID: number;
    tenantImageURL: string;
    tenantTitle: string;

    tenantSubscriptionStart: string;
    tenantSubscriptionEnd: string;
    tenantSubscriptionActive: boolean;

    roles: string[];

    imageUrl: string;
    imageListUrl: string;
    fileListUrl: string;
    allowCreate: boolean;
}

@inject(
    Stores.UserStore,
    Stores.SessionStore,
    Stores.InfoHubStore,
    Stores.InventoryStore,
    Stores.MenuStore,
    Stores.PaymentStore,
    Stores.PeopleStore,
    Stores.ReportStore,
    Stores.RoleStore,
    Stores.SchedulingStore,
    Stores.TeamStore,
    Stores.WorkOrderStore,
    Stores.IntegrationStore)
@observer
class ModelsBase extends AppComponentBase<IModelsBaseProps, IModelsBaseState>
{

    state = {
        allowCreate: false,
        collapseTitle: false,
        deleteDrawerVisible: false,
        createModalVisible: false,
        editModalVisible: false,
        isMobile: false,
        cardHeight: '',
        defaultProfileImage: '',
        maxResultCount: 10,
        skipCount: 0,
        tenantId: 0,
        filter: '',
        loading: true,
        dataTableText: L('Fetching Data...'),
        formSize: '',
        cardSize: '',
        searchSize: '',
        tableSize: '',

        currentTab: 'swilab',

        roles: [],

        currentUserID: 0,
        currentLoginName: '',
        currentLoginLastName: '',
        profileImageID: 0,
        profileImageURL: '',
        currentUsername: '',
        currentEmailAddres: '',

        currentTenantName: '',
        primaryTenantColor: '#dadada',
        secondaryTenantColor: '#dadada',

        tenantImageID: 0,
        tenantImageURL: 'https://swilab.com/images/devLogo.png',
        tenantTitle: '',

        tenantSubscriptionStart: '',
        tenantSubscriptionEnd: '',
        tenantSubscriptionActive: false,

        imageUrl: '',
        imageListUrl: '',
        fileListUrl: '',
    };

    async componentDidMount() {

        this.setState({
            loading: true,
            formSize: (window.innerWidth).toString() + 'px',
            tableSize: (window.innerWidth * 0.95).toString() + 'px',
        });

        if (window.innerWidth >= 550) {
            this.setState({
                cardHeight: '60px',
                isMobile: false
            });
        }
        else {
            this.setState({
                cardHeight: '100px',
                isMobile: true
            });
        }

        if (window.innerWidth >= 750) {
            this.setState({
                collapseTitle: false
            });
        }
        else {
            this.setState({
                collapseTitle: true
            });
        }

         this.setState({

            currentLoginName: this.props.sessionStore.currentLogin.user.name,
            currentLoginLastName: this.props.sessionStore.currentLogin.user.surname,
            profileImageID: this.props.sessionStore.currentLogin.user.profileImageID,
            profileImageURL: this.props.sessionStore.currentLogin.user.profileImageURL,
            currentUsername: this.props.sessionStore.currentLogin.user.userName,
            currentEmailAddres: this.props.sessionStore.currentLogin.user.emailAddress,
            currentTenantName: this.props.sessionStore.currentLogin.tenant.tenancyName,
            primaryTenantColor: this.props.sessionStore.currentLogin.tenant.primaryColor,
            secondaryTenantColor: this.props.sessionStore.currentLogin.tenant.secondaryColor,
            tenantImageID: this.props.sessionStore.currentLogin.tenant.profileImageID,
            tenantImageURL: this.props.sessionStore.currentLogin.tenant.profileImageURL,
            tenantTitle: this.props.sessionStore.currentLogin.tenant.title,
            //tenantSubscriptionStart: currentLoginInfo.tenant.SubscriptionStart.toDateString(),
            //tenantSubscriptionEnd: currentLoginInfo.tenant.SubscriptionExpire.toDateString(),
            tenantSubscriptionActive: this.props.sessionStore.currentLogin.tenant.subscriptionActive,
            roles: this.props.sessionStore.currentLogin.roles,
            currentUserID: this.props.sessionStore.currentLogin.user.userID, 

        });



        this.setState({
            loading: false,
        });

        window.addEventListener('resize', this.handleResize);
    }

    handleResize = () => {

        this.setState({
            formSize: (window.innerWidth).toString() + 'px',
            tableSize: (window.innerWidth * 0.95).toString() + 'px'
        });

        if (window.innerWidth >= 550) {
            this.setState({
                cardHeight: '60px',
                isMobile: false
            });
        }
        else {
            this.setState({
                cardHeight: '100px',
                isMobile: true
            });
        }

        if (window.innerWidth >= 750) {
            this.setState({
                collapseTitle: false
            });
        }
        else {
            this.setState({
                collapseTitle: true
            });
        }

    }

    //----------------------------------------

    public render() {

        return (

            <div style={{ marginTop: '25px', textAlign: 'center', }}>

                {this.state.loading === true ? <Spin indicator={<LoadingOutlined style={{ fontSize: 20, color: '#ddd' }} spin />} /> :

                    <div>

                        <CategoryTitle
                            title={L('Models')}
                            isMobile={this.state.collapseTitle}
                            primaryColor={this.state.primaryTenantColor}
                            secondaryColor={this.state.secondaryTenantColor}
                        />

                        <Card>
                            <iframe style={{height: window.innerHeight * 0.8, width: '100%', border: 'none'}} src="https://threejs.org/editor/"></iframe>
                        </Card>


                    </div>
                }

            </div>

        );
    }
}

export default ModelsBase;
